// extracted by mini-css-extract-plugin
export default {"menu":"dropdown-menu_menu__GP8Ug","menu-visible":"dropdown-menu_menu-visible__s+tBA"};